<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>注意事项</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">注意事项</div>
      </div>
    </div>

    <div class="layout-content" style="padding:40px;min-height: 500px;">
      <div v-for="(item, index) in list" :key="index" style="max-width:1000px">
        <Row>
          <iCol span="20">{{item.text}} </iCol>
          <iCol span="4" class="f-tal">{{item.inTime | moment("YYYY/MM/DD HH:mm")}}</iCol>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  props: {},
  data () {
    return {
      list: null,
    };
  },
  watch: {},
  computed: {
    ...mapGetters({
      exhibition: 'loginModule/getExhibition',
    }),
  },
  methods: {
    ...mapActions({
      getExhibitionPayAttentionByExId: "registerdModule/getExhibitionPayAttentionByExId",
    }),
    async getExhibitionPayAttentionHandle () {
      let res = await this.getExhibitionPayAttentionByExId(this.exhibition.id);
      if (res) {
        res.reverse();
        this.list = res;
      }
      console.log('getExhibitionPayAttentionHandle', res);
    },
  },
  created () {
    this.getExhibitionPayAttentionHandle();
  },
}

</script>

<style lang="scss" scoped>
</style>
